/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getUserOrganizationsResponse = zod.object({
  "currentOrganizationId": zod.string().uuid().nullish(),
  "organizations": zod.array(zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "userId": zod.string().uuid(),
  "roleCode": zod.string().nullish(),
  "isStaff": zod.boolean(),
  "isTalent": zod.boolean(),
  "isActive": zod.boolean(),
  "joinDate": zod.string().datetime({}),
  "organizationName": zod.string(),
  "logoUrl": zod.string().nullish()
}))
})

export const createOrganizationBodyNameMax = 255;



export const createOrganizationBody = zod.object({
  "name": zod.string().min(1).max(createOrganizationBodyNameMax),
  "isActive": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const updateCurrentOrganizationBodyNameMax = 255;



export const updateCurrentOrganizationBody = zod.object({
  "name": zod.string().min(1).max(updateCurrentOrganizationBodyNameMax),
  "isActive": zod.boolean()
})

export const updateCurrentOrganizationResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "logoUrl": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const setLogoBody = zod.object({
  "blobId": zod.string().uuid()
})

export const getFormerOrganizationsResponseItem = zod.object({
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "logoUrl": zod.string().nullish(),
  "leaveDate": zod.string().datetime({}),
  "organizationIsActive": zod.boolean(),
  "roleCode": zod.string().nullish(),
  "pendingInvitations": zod.array(zod.object({
  "id": zod.string().uuid(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "role": zod.string()
}))
})
export const getFormerOrganizationsResponse = zod.array(getFormerOrganizationsResponseItem)

export const restoreOrganizationParams = zod.object({
  "organizationId": zod.string().uuid()
})

export const restoreOrganizationResponse = zod.object({
  "organizationId": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_TRANSFER
 */
export const getTransferCandidatesResponseItem = zod.object({
  "userId": zod.string().uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string().nullish(),
  "roleCode": zod.string().nullish()
})
export const getTransferCandidatesResponse = zod.array(getTransferCandidatesResponseItem)

/**
 * **Required Permission(s):** ORG_TRANSFER
 */
export const transferOrganizationBody = zod.object({
  "newOwnerId": zod.string().uuid()
})

export const transferOrganizationResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "isActive": zod.boolean(),
  "logoUrl": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "modifiedDate": zod.string().datetime({}),
  "createdByUserId": zod.string().uuid().nullish(),
  "modifiedByUserId": zod.string().uuid().nullish()
})

export const getOrganizationSettingsResponse = zod.object({
  "gpsProximityThresholdFeet": zod.number(),
  "timeZoneId": zod.string().nullish(),
  "funding": zod.object({
  "autoTopUp": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number(),
  "targetBalance": zod.number()
}),
  "leadTimeBusinessDays": zod.number()
}),
  "notifications": zod.object({
  "lowBalanceNotification": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number()
}),
  "pendingPayoutDigest": zod.object({
  "enabled": zod.boolean(),
  "sendTime": zod.string().time({})
}),
  "weeklyEarningsDigest": zod.object({
  "enabled": zod.boolean(),
  "dayOfWeek": zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
  "sendTime": zod.string().time({})
})
}),
  "showDirectPayoutOnHome": zod.boolean(),
  "showDirectPayoutOnPay": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "payoutPolicyEnabled": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const updateOrganizationSettingsBody = zod.object({
  "gpsProximityThresholdFeet": zod.number(),
  "timeZoneId": zod.string().nullish(),
  "funding": zod.object({
  "autoTopUp": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number(),
  "targetBalance": zod.number()
}),
  "leadTimeBusinessDays": zod.number()
}),
  "notifications": zod.object({
  "lowBalanceNotification": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number()
}),
  "pendingPayoutDigest": zod.object({
  "enabled": zod.boolean(),
  "sendTime": zod.string().time({})
}),
  "weeklyEarningsDigest": zod.object({
  "enabled": zod.boolean(),
  "dayOfWeek": zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
  "sendTime": zod.string().time({})
})
}),
  "showDirectPayoutOnHome": zod.boolean(),
  "showDirectPayoutOnPay": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "payoutPolicyEnabled": zod.boolean()
})

export const updateOrganizationSettingsResponse = zod.object({
  "gpsProximityThresholdFeet": zod.number(),
  "timeZoneId": zod.string().nullish(),
  "funding": zod.object({
  "autoTopUp": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number(),
  "targetBalance": zod.number()
}),
  "leadTimeBusinessDays": zod.number()
}),
  "notifications": zod.object({
  "lowBalanceNotification": zod.object({
  "enabled": zod.boolean(),
  "threshold": zod.number()
}),
  "pendingPayoutDigest": zod.object({
  "enabled": zod.boolean(),
  "sendTime": zod.string().time({})
}),
  "weeklyEarningsDigest": zod.object({
  "enabled": zod.boolean(),
  "dayOfWeek": zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']),
  "sendTime": zod.string().time({})
})
}),
  "showDirectPayoutOnHome": zod.boolean(),
  "showDirectPayoutOnPay": zod.boolean(),
  "pushToCardEnabled": zod.boolean(),
  "payoutPolicyEnabled": zod.boolean()
})

